import { createSlice } from "@reduxjs/toolkit";
import { DefaultRangesTypes, PredefinedRangesByKey } from "components/DateRange/DefaultRanges";

const initialState = {
    vendorId: null,
    clientId: null,
    clientAccountId: null,
    startDate: PredefinedRangesByKey[DefaultRangesTypes.THIRTY_DAYS].range().startDate.toDateString(),
    endDate: PredefinedRangesByKey[DefaultRangesTypes.THIRTY_DAYS].range().endDate.toDateString(),
    rangeType: DefaultRangesTypes.THIRTY_DAYS
};

const dashboardFiltersSlice = createSlice({
    name: "dashboardFilters",
    initialState,
    reducers: {
        setVendorId(state, action) {
            state.vendorId = action.payload;
        },
        setClientId(state, action) {
            state.clientId = action.payload;
        },
        setClientAccountId(state, action) {
            state.clientAccountId = action.payload;
        },
        setStartDate(state, action) {
            state.startDate = action.payload;
        },
        setEndDate(state, action) {
            state.endDate = action.payload;
        },
        setRangeType(state, action) {
            state.rangeType = action.payload;
        },
    },
});

export const { setVendorId, setClientAccountId, setClientId, setStartDate, setEndDate, setRangeType } = dashboardFiltersSlice.actions;
export const selectVendorId = state => state.dashboardFilters.vendorId;
export const selectClientId = state => state.dashboardFilters.clientId;
export const selectClientAccountId = state => state.dashboardFilters.clientAccountId;
export const selectStartDate = state => state.dashboardFilters.startDate;
export const selectEndDate = state => state.dashboardFilters.endDate;
export const selectRangeType = state => state.dashboardFilters.rangeType;

export default dashboardFiltersSlice.reducer;
